import { makeStyles } from '@material-ui/core/styles';
import { Theme } from 'enum';

export const useStyle = makeStyles((theme) => ({
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    logoContainer: {
        width: '100px',
        height: '100px',
        borderRadius: '50%',
        backgroundColor: '#fff',
        boxShadow: `${theme.palette.type === Theme.Light ? '0 0 16px #eee' : '0 0 16px #111'}`,
        margin: theme.spacing(4),
        marginTop: 0,
        [theme.breakpoints.down('xs')]: {
            marginBottom: theme.spacing(3),
            width: '80px',
            height: '80px',
        },
    },
    logo: {
        width: '100%',
        borderRadius: '50%',
    },
    container: {
        padding: theme.spacing(3),
        backgroundColor: theme.palette.background.paper,
    },
}));
